<template>
  <span>
    <input v-model="value" type="hidden" :id="inputId" :name="inputName" />
    <vue-tel-input v-model="value"></vue-tel-input>
  </span>
</template>

<script>
import Vue from "vue";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

Vue.use(VueTelInput, {
  preferredCountries: ["id"],
  defaultCountry: "id",
  mode: "international",
  inputOptions: {
    placeholder: "Nomor telepon / Phone number",
  },
});

export default {
  props: {
    inputName: {
      type: String,
      required: true,
    },
    inputId: {
      type: String,
      required: true,
    },
    initValue: {
      type: String,
      required: false,
    },
  },
  name: "PhoneNumberInput",
  data() {
    return {
      // define the default value
      value: this.initValue,
    };
  },
};
</script>
